import { Container, Group, AsideContainer } from '../styles';
import { AddressCompanyDataType } from '../types';

interface BillingAddressCard {
  address: AddressCompanyDataType
}

export default function BillingAddressCard({ address }: BillingAddressCard) {
  return (
    <Container>
      <div className="card-title">
        Endereço faturamento
      </div>
      <AsideContainer>
        <Group aside>
          <div className="title">
            CEP
          </div>
          <span>
            {address?.cep || 'Não informado'}
          </span>
        </Group>
        <Group aside>
          <div className="title">
            UF
          </div>
          <span>
            {address?.uf || 'Não informado'}
          </span>
        </Group>
      </AsideContainer>
      <AsideContainer>
        <Group aside>
          <div className="title">
            Cidade
          </div>
          <span>
            {address?.city || 'Não informado'}
          </span>
        </Group>
        <Group aside>
          <div className="title">
            Bairro
          </div>
          <span>
            {address?.district || 'Não informado'}
          </span>
        </Group>
      </AsideContainer>
      <Group>
        <div className="title">
          Logradouro
        </div>
        <span>
          {address?.streetName || 'Não informado'}
        </span>
      </Group>
      <AsideContainer>
        <Group aside>
          <div className="title">
            Número
          </div>
          <span>
            {address?.number || 'Não informado'}
          </span>
        </Group>
        <Group aside>
          <div className="title">
            Complemento
          </div>
          <span>
            {address?.complement || 'Não informado'}
          </span>
        </Group>
      </AsideContainer>
    </Container>
  );
}
